export default __webpack_public_path__ + "static/media/auth.9f498910.jpg";